import debug from 'debug';

const channel = 'seoye';

/**
 * debug를 한 번 더 감싸주는 이유는 항상 debug가 동작하지 않게 하기 위함이다. 동작은 하는데 출력은 하지 않는 것과, noop function은
 * 성능차이를 만들기 때문에 production 에서는 debug가 아예 동작하지 않도록 wrapper를 만들어준다.
 *
 * @param channel 채널
 */
export default function llc(filename: string): debug.IDebugger {
  if (process.env.NODE_ENV !== 'development') {
    const nulllog: any = () => undefined;
    return nulllog;
  }

  return debug(`${channel}:${filename.replace(/(\/)(.+)(\.ts|\.tsx|\.js|\.jsx)/, '$2')}`);
}
